import React, { FC, useEffect, useRef, useState } from 'react';
import styles from './ModalContract.module.scss';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';
import { Modal } from 'components/Modal';
import { getFormatPhone } from 'utils/getFotmatPhone';
import classNames from 'classnames';
import { PatternFormat } from 'react-number-format';
import {
  useLazyGetSmsCodeQuery,
  useSignContactMutation,
} from 'redux/Api/profileApi/ProfileApi';
import { Loader } from '@mantine/core';

interface ModalProfileTypes {
  setShowModalContract: (e: boolean) => void;
  setStartTimer: (e: boolean) => void;
  timer: number;
  startTimer: boolean;
}

interface ApiError {
  data: {
    message: string;
  };
}

const isApiError = (error: unknown): error is ApiError => {
  return typeof error === 'object' && error !== null && 'data' in error;
};

export const ModalContract: FC<ModalProfileTypes> = ({
  setShowModalContract,
  setStartTimer,
  timer,
  startTimer,
}) => {
  const patternFormatRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState('');
  const phone = localStorage.getItem('phone');
  const [signContract, { data, error, isLoading }] = useSignContactMutation();
  const [getCode, { error: errorGetCode }] = useLazyGetSmsCodeQuery();

  const apiError = error && isApiError(error) ? error : null;
  const apiErrorGetCode = errorGetCode && isApiError(errorGetCode) ? errorGetCode : null;

  const signHandler = async () => {
    if (value.length === 6) {
      await signContract({
        body: {
          code: Number(value),
        },
      });
    }
  };

  useEffect(() => {
    if (data) setShowModalContract(false);
  }, [data]);

  useEffect(() => {
    if (timer === 60) {
      getCode();
    }
    if (patternFormatRef.current) {
      patternFormatRef.current.focus();
    }
  }, []);

  const getCodeAgain = () => {
    if (timer === 60) {
      getCode();
      setStartTimer(true);
    }
  };

  const keyHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && value.length === 6) {
      signHandler();
    }
  };

  return (
    <Modal setOpen={setShowModalContract}>
      <div className={styles.root}>
        <Title className={styles.root_title} title='Подписание договора' />
        <p className={styles.root_text}>
          Введите код отправленный на номер <b>{getFormatPhone(phone)}</b>
        </p>
        <div className={styles.root_inputBlock}>
          <p>Код подтверждения</p>
          <PatternFormat
            onKeyDown={(e) => keyHandler(e)}
            getInputRef={patternFormatRef}
            className={classNames(styles.input, apiError && styles.input_error)}
            format='###-###'
            placeholder=''
            onValueChange={(values: { value: string; formattedValue?: string }) => {
              setValue(values.value);
            }}
            value={value}
          />
          {apiError?.data.message && (
            <p style={{ color: '#E10D0D' }}>{apiError.data.message}</p>
          )}
        </div>
        <Button
          spanStyle={value.length < 6 ? { color: '#71869D' } : {}}
          disabled={value.length < 6}
          onClick={signHandler}
          className={styles.root_btn}
          theme='filed'>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            Подтвердить {isLoading && <Loader size='xs' color='white' />}
          </div>
        </Button>
        <p
          style={
            !startTimer
              ? { cursor: 'pointer', color: '#002cfb' }
              : { cursor: 'not-allowed' }
          }
          onClick={getCodeAgain}
          className={styles.root_link}>
          {apiErrorGetCode?.data.message && timer !== 60 ? (
            <>
              {apiErrorGetCode.data.message} <span>{timer} сек</span>
            </>
          ) : (
            <>
              Не пришло смс? Запросите еще одно
              {timer !== 60 && (
                <>
                  {' '}
                  через <span>{timer} сек</span>
                </>
              )}
            </>
          )}
        </p>
      </div>
    </Modal>
  );
};
